import { useCallback, useState } from 'react'

/**
 * Width of an element, kept current with a ResizeObserver. Returns a
 * callback ref and the last measured width (0 until mounted).
 */
export function useElementWidth<T extends HTMLElement>(): [(node: T | null) => void, number] {
  const [width, setWidth] = useState(0)
  const [observer] = useState(() =>
    typeof ResizeObserver === 'undefined'
      ? null
      : new ResizeObserver((entries) => {
          const entry = entries[0]
          if (entry) setWidth(Math.round(entry.contentRect.width))
        }),
  )
  const ref = useCallback(
    (node: T | null) => {
      if (!observer) return
      observer.disconnect()
      if (node) {
        observer.observe(node)
        setWidth(Math.round(node.getBoundingClientRect().width))
      }
    },
    [observer],
  )
  return [ref, width]
}
